import type { Icons } from '@/components/base/BaseIcon.vue'

export function getActivityIconFromSlug(slug: string | null | undefined): Icons | null {
  if (!slug) {
    return null
  }

  let normalizedSlug = slug.trim().toLowerCase()

  let suffix: 'Solid' | 'Outline' = 'Solid'

  if (normalizedSlug.endsWith('-outline')) {
    suffix = 'Outline'
    normalizedSlug = normalizedSlug.replace(/-outline$/, '')
  }

  const pascal = normalizedSlug
    .split(/[-_\s]+/)
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join('')

  const heroName = `Hero${pascal}Icon${suffix}` as Icons

  return heroName
}
